export const GET_SERVICE_STATUS_BY_NAME = 'GET_SERVICE_STATUS_BY_NAME';
